import EA from '../helpers/init';

export default EA.Methods.openMobileMenuItems = ($this) => {
    const gridOpener = $this.querySelector('.mobile-menu-dropdown-item-opener');
    const gridContent = $this.querySelector('.mobile-menu-dropdown-item-content');
    const gridArrow = $this.querySelector('.mobile-menu-dropdown-item-arrow');

    gridOpener.addEventListener('click', () => {
        gridArrow.classList.toggle('active');
        gridContent.classList.toggle('active');
    });
};
